import { Button, ChevronIcon, Colors, FlexBox, InlineText } from '@helloself/hello-self-ui';
import { useHistory } from 'react-router-dom';

import { IconEdit } from '../../../ui';

interface ToolbarProps {
    isOwnProfile: boolean;
    setIsEditOpen?: (isOpen: boolean) => void;
    onBackClick?: () => void;
    onEditClick?: () => void;
}

export function Toolbar({ isOwnProfile, setIsEditOpen, onBackClick, onEditClick }: ToolbarProps) {
    const history = useHistory();
    const fontColor = isOwnProfile ? Colors.white : Colors.MemberGreen500;

    const handleBackClick = () => {
        onBackClick?.();
        history.goBack();
    };

    const handleEditClick = () => {
        onEditClick?.();
        setIsEditOpen?.(true);
    };

    return (
        <FlexBox height="18px" width="100%" justifyContent="space-between">
            <Button
                size="auto"
                display="transparent"
                onClick={handleBackClick}
                className="hover:opacity-50 transition-opacity duration-150 ease-in-out"
            >
                <FlexBox height="18px" alignItems="center" gap="4px">
                    <ChevronIcon color={fontColor} height="16px" width="16px" />
                    <InlineText lineHeight="18px" fontSize="14px" fontWeight="600" textColor={fontColor}>
                        Back
                    </InlineText>
                </FlexBox>
            </Button>

            {isOwnProfile && setIsEditOpen && (
                <FlexBox alignItems="center">
                    <Button
                        size="auto"
                        display="transparent"
                        onClick={handleEditClick}
                        className="hover:opacity-50 transition-opacity duration-150 ease-in-out"
                    >
                        <InlineText
                            lineHeight="18px"
                            margin="0 4px 0 0"
                            fontSize="14px"
                            fontWeight="600"
                            textColor={fontColor}
                        >
                            Edit
                        </InlineText>
                        <IconEdit color="white" height="16px" width="16px"></IconEdit>
                    </Button>
                </FlexBox>
            )}
        </FlexBox>
    );
}
